import Icon from '../components/Icon.vue'

Icon.register({
  'virus-slash': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M114 227.6c9.9-0.1 19.7-2.9 28.1-8l244.5 189c-21.2 7.5-38.2 26.8-38.2 53.4v21.5c0 15.7-12.7 28.4-28.4 28.4s-28.5-12.7-28.5-28.4v-21.5c0-50.7-61.3-76-97.1-40.2l-15.2 15.2c-0.5 0.6-1.1 1.1-1.6 1.6-11.5 10.6-29.6 9.9-40.2-1.6-10.6-11.5-9.9-29.5 1.6-40.2l15.2-15.3c35.9-35.8 10.5-97.1-40.2-97.1h-21.6c-15.7 0-28.4-12.7-28.4-28.4s12.7-28.4 28.4-28.4h21.6zM617 505.8c-5.4 7-15.5 8.3-22.4 2.9l-588.4-454.7c-7-5.5-8.2-15.5-2.8-22.5l19.6-25.3c5.5-7 15.5-8.2 22.5-2.8l93.2 72.1c11.1-11.1 29.4-11.6 40.5-0.5l15.3 15.2c35.8 35.9 97.1 10.5 97.1-40.2v-21.6c0-15.7 12.7-28.4 28.4-28.4s28.4 12.7 28.5 28.5v21.6c0 50.7 61.3 76 97.1 40.2l15.2-15.2c10.9-10.1 27.7-10.1 38.6 0 11.6 10.7 12.3 28.7 1.6 40.2l-15.2 15.3c-35.9 35.8-10.5 97.1 40.2 97.1h21.5c15.7 0 28.4 12.7 28.4 28.4 0 15.7-12.7 28.4-28.4 28.4h-21.5c-30.5 0-51.2 22.1-55.4 47.5l163.2 126c7 5.5 8.2 15.5 2.8 22.5zM335.4 227.5c0.1-1.2 0.6-2.3 0.5-3.5 0-26.5-21.5-48-48-48-5.2 0.1-10.5 1.1-15.4 2.9z'
      }
    ]
  }
})
